import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { Tabs, Tab } from 'ionic-angular';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { RegisterPage } from '../pages/register/register';
import { GroupsPage} from '../pages/groups/groups';
import { ElementsPage } from '../pages/elements/elements';
import { DataPage } from '../pages/data/data';
import { HandmadeQueriesPage } from "../pages/handmade-queries/handmade-queries";
import { GroupPropertiesPage } from "../pages/groupProperties/groupProperties";
import { ParticipantPropertiesPage } from "../pages/participantProperties/participantProperties";
import { CliPage} from "../pages/cli/cli";

import { ApiServiceProvider } from '../providers/api.service';
import { FiltersServiceProvider } from '../providers//filters.service';
import { GlobalServiceProvider } from "../providers/global.service";
import { CommandResolver} from "../components/commands/command-resolver";

import { MajimeHeaderbarComponent } from "../components/headerbar/majime-headerbar";
import { MajimeParticipantGroupComponent } from "../components/majime-participant-group/majime-participant-group";
import { MajimeParticipantComponent } from "../components/majime-participant/majime-participant";

import { ListCommandsComponent} from "../components/commands/list-commands/list-commands";

import { CommandLineComponent} from "../components/command-line/command-line";
import { CommandOutputComponent} from "../components/command-output/command-output";

import { ParticipantListCmdComponent } from "../components/commands/participant-list-cmd/participant-list-cmd";
import { DocumentListCmdComponent } from "../components/commands/document-list-cmd/document-list-cmd";
import { ParticipantDetailCmdComponent } from "../components/commands/participant-detail-cmd/participant-detail-cmd";
import { DocumentDetailCmdComponent } from "../components/commands/document-detail-cmd/document-detail-cmd";

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    RegisterPage,

    GroupsPage,
    GroupPropertiesPage,
    ParticipantPropertiesPage,

    ElementsPage,
    DataPage,
    HandmadeQueriesPage,
    CliPage,

    MajimeHeaderbarComponent,
    MajimeParticipantGroupComponent,
    MajimeParticipantComponent,
    CommandLineComponent,
    ListCommandsComponent,
    CommandOutputComponent,
    ParticipantListCmdComponent,
    DocumentListCmdComponent,
    ParticipantDetailCmdComponent,
    DocumentDetailCmdComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    RegisterPage,
    GroupsPage,
    GroupPropertiesPage,
    ParticipantPropertiesPage,
    ElementsPage,
    DataPage,
    HandmadeQueriesPage,
    CliPage,
    ListCommandsComponent,
    CommandOutputComponent,
    ParticipantListCmdComponent,
    DocumentListCmdComponent,
    ParticipantDetailCmdComponent,
    DocumentDetailCmdComponent

  ],

  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},

    ApiServiceProvider,
    GlobalServiceProvider,
    FiltersServiceProvider,
    CommandResolver,
    // NewlyCreatedComponentProvider,

  ],


  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],


})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts